module.exports = __webpack_public_path__ + "static/media/yellow-signs-mobiles-2-tiny.07d3fe60.jpg";